module.exports = __webpack_public_path__ + "img/edit.ef4238f5.svg";